import { Skeleton, Stack, Grid } from '@mui/material'

export default function MySkeletonGrid({ gridArray }) {
  return (
    <Grid container spacing={2}>
      {gridArray.map((item, index) => (
        <Grid item xs={item.xs} key={index}>
          <Stack spacing={0.5}>
            <Skeleton variant="rectangular" animation="wave" height={'30px'} width={'100%'} sx={{ background: '#e2e8f0', borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }} />
            <Skeleton variant="rectangular" animation="wave" height={'100px'} width={'100%'} sx={{ background: '#e2e8f0', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }} />
          </Stack>
        </Grid>
      ))}
    </Grid>
  )
}
